import React from 'react'
import Text from '../../../components/text/Text'
import './CommunicationChannel.css'
import greenIcon from '../../../assets/icons/c-channel-icon-1.png'
import channelUser from '../../../assets/icons/c-channel-icon-5.png'

import commuCheckIcon from '../../../assets/icons/commu-check-icon.png'
import commuDownloadIcon from '../../../assets/icons/commu-download-icon.png'
import commuMailIcon from '../../../assets/icons/commu-mail-icon.png'
import { track } from '../../../ClevertapWrapper'
import { clevertapEvents } from '../../../labels'
import routes from '../../../router/routes'
import { format } from 'date-fns'

export default function CommunicationChannel() {
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)

    const communicationChannelEventParms = {
        pageName: 'CommunicationChannel',
        pageURL: routes.communication,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        codComercio: user?.sEstablecimiento,
        nombreComercio: user?.sNombre,
        codLocal: user?.cLocal[0].sLocal,
        rut: user?.sRut,
        mailLogin: user?.sEmailContacto,
    }
    return (
        <div className="button-container">
            <div className="grey-container">
                <div className="flexRow banners">
                    <Text
                        label="💬 Bienvenido a tu Canal de Comunicación"
                        fontWeight={700}
                        fontSize={24}
                        color={'white'}
                    />
                </div>
            </div>
            <div className="blue-container">
                <div className="flexRow banners">
                    <Text
                        label="📊 Ver Oportunidades"
                        fontWeight={700}
                        fontSize={24}
                        color={'white'}
                    />
                    <Text
                        label=". . . "
                        color={'#0085ff'}
                        fontWeight={600}
                        marginLeft={10}
                    />
                </div>
            </div>
            <div className="blue-container">
                <div className="flexRow banners">
                    <Text
                        label="💸  Consultar Pagos Pendientes"
                        fontWeight={700}
                        fontSize={24}
                        color={'white'}
                    />
                    <Text
                        label=". . . "
                        color={'#0085ff'}
                        fontWeight={600}
                        marginLeft={10}
                    />
                </div>
            </div>
            <div className="flexRow">
                <div className="news-container">
                    <div>
                        <Text
                            label="amiNovedades"
                            fontWeight={400}
                            fontSize={24}
                            marginTop={16}
                            color={'#0086D6'}
                        />
                        <Text
                            label="Este mes"
                            fontWeight={400}
                            fontSize={14}
                            marginTop={6}
                            color={'#0F1113'}
                            marginBottom={10}
                        />
                    </div>
                    <div className="flexRow">
                        <div className="flexCol">
                            <img src={commuDownloadIcon} className="blue-img" />
                            <img src={greenIcon} className="green-img" />
                        </div>
                        <div className="text-margin">
                            <Text
                                label="Descubre la nueva app de amiPOS."
                                fontWeight={400}
                                fontSize={12}
                                color={'#0F1113'}
                            />
                            <Text
                                label="10:15 AM"
                                fontWeight={400}
                                fontSize={10}
                                color={'#6F7071'}
                                marginBottom={20}
                            />

                            <Text
                                label="¿Ya conoces la nueva alianza que tenemos con BCI?"
                                fontWeight={400}
                                fontSize={12}
                                color={'#0F1113'}
                            />
                            <Text
                                label="9:00 AM"
                                fontWeight={400}
                                fontSize={10}
                                color={'#6F7071'}
                            />
                        </div>
                    </div>
                    <Text
                        label="Anteriores"
                        fontWeight={400}
                        fontSize={14}
                        marginTop={6}
                        color={'#0F1113'}
                        marginBottom={20}
                    />
                    <div className="flexRow">
                        <div className="flexCol">
                            <img src={commuCheckIcon} className="check-img" />
                            <img src={commuMailIcon} className="blue-img" />
                            <img src={channelUser} className="green-img" />
                        </div>
                        <div className="text-margin">
                            <Text
                                label="Nueva funcionalidad, Canal de Comunicaciones."
                                fontWeight={400}
                                fontSize={12}
                                color={'#0F1113'}
                            />

                            <Text
                                label="04:30 AM"
                                fontWeight={400}
                                fontSize={10}
                                color={'#6F7071'}
                            />

                            <Text
                                label="Conoce las misiones de amiPOS."
                                fontWeight={400}
                                fontSize={12}
                                color={'#0F1113'}
                                marginTop={20}
                            />
                            <Text
                                label="02:45 PM"
                                fontWeight={400}
                                fontSize={10}
                                color={'#6F7071'}
                                marginBottom={17}
                            />
                            <Text
                                label="Nuevas Funcionalidades de amiPOS."
                                fontWeight={400}
                                fontSize={12}
                                color={'#0F1113'}
                            />
                            <Text
                                label="01:00 PM"
                                fontWeight={400}
                                fontSize={10}
                                color={'#6F7071'}
                            />
                        </div>
                    </div>
                </div>

                <div className="help-chat-container">
                    <div></div>
                    <Text
                        label="📢 Chat de ayuda"
                        fontWeight={600}
                        fontSize={25}
                        color={'white'}
                        marginBottom={10}
                    />

                    <Text
                        label="Nuestro equipo está siempre atento"
                        fontWeight={700}
                        fontSize={13}
                        color={'white'}
                        marginTop={5}
                    />
                    <Text
                        label="para poder ofrecerte orientación en"
                        fontWeight={700}
                        fontSize={13}
                        color={'white'}
                        marginTop={5}
                    />
                    <Text
                        label="nuestros canales de ayuda y atención"
                        fontWeight={700}
                        fontSize={13}
                        color={'white'}
                        marginTop={5}
                    />

                    <button
                        className="button-style-communication-channel"
                        onClick={() => {
                            window.open(
                                'https://amipassmerchants.zendesk.com/hc/es-419'
                            )
                            // if (window.zE) {
                            //     window.zE('messenger', 'open')

                            // }
                            track(
                                clevertapEvents.amiposweb_mi_cuenta_canaldecomunicacion_chatayuda,
                                communicationChannelEventParms
                            )
                        }}
                    >
                        <Text
                            label="Iniciar Conversación"
                            fontSize={14}
                            fontWeight={500}
                            color={'#0085FF'}
                        />
                    </button>
                </div>
            </div>
        </div>
    )
}
